import { Box, Button, styled } from '@mui/material';
import { GridContainer } from 'components/shared/Grid/Grid.components';

export const AppointmentFormContainer = styled(GridContainer)({
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column'
});

export const BaseMrpButton = styled(Button)(({ theme }) => ({
  color: theme.vars.palette.text.primary,
  fontSize: theme.vars.font.button,
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  borderRadius: '5px',
  backgroundColor: 'white',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  border: `1px solid ${theme.palette.grey[400]}`,
  '&:hover': {
    borderColor: theme.palette.primary.main
  }
}));

export const IconButton = styled(BaseMrpButton)(({ theme }) => ({
  border: 'none',
  height: '100%',
  aspectRatio: '1/1',
  minWidth: 0,
  fontSize: '20px',
  marginLeft: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.vars.palette.Button.inheritContainedHoverBg
  }
}));

export const SpacedBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const CalendarScrollContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: '450px',
  maxHeight: 'calc(100vh - 300px)',
  flexBasis: `calc(50% - ${theme.spacing(4)})`
}));
